import React from 'react';
import serviceThumb from '../../assets/images/partner-ship-image.png';

function ServicesHomeEight() {
    return (
        <>
            <section
                className="appie-services-2-area appie-services-8-area pt-90 pb-55 bg-light"
                id="service"
            >
                <div className="container">
                    <div className="row align-items-end">
                        <div className="col-lg-6 col-md-8">
                            <div className="appie-section-title">
                                <h3 className="appie-title">Why Partner with OTO?</h3>
                                <p>Boost your earnings with recurring monthly commissions</p>
                            </div>
                        </div>
                    </div>
                    <div className="row align-items-center">
                        <div className="col-lg-7 order-1 order-xs-0 order-md-0 order-sm-1">
                            <div className="row">
                                <div className="col-lg-6 col-md-6">
                                    <div
                                        className="
                    appie-single-service-2 appie-single-service-about
                    mt-30
                    wow
                    animated
                    fadeInUp
                  "
                                        data-wow-duration="2000ms"
                                        data-wow-delay="200ms"
                                    >
                                        <div className="icon">
                                            <i className="fal fa-chart-line" />
                                        </div>
                                        <h4 className="title">High-demand products</h4>
                                        <p>
                                            Our software suite offers essential solutions for
                                            businesses of all sizes, making it easy to sell in
                                            various industries
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div
                                        className="
                    appie-single-service-2 appie-single-service-about
                    item-2
                    mt-30
                    wow
                    animated
                    fadeInUp
                  "
                                        data-wow-duration="2000ms"
                                        data-wow-delay="400ms"
                                    >
                                        <div className="icon">
                                            <i className="fal fa-badge-percent" />
                                        </div>
                                        <h4 className="title">Competitive commission rates</h4>
                                        <p>
                                            We offer competitive commission rates for each
                                            successful sale, with the added benefit of recurring
                                            monthly commissions.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div
                                        className="
                    appie-single-service-2 appie-single-service-about
                    item-3
                    mt-30
                    wow
                    animated
                    fadeInUp
                  "
                                        data-wow-duration="2000ms"
                                        data-wow-delay="600ms"
                                    >
                                        <div className="icon">
                                            <i className="fal fa-user-headset" />
                                        </div>
                                        <h4 className="title">Reliable support</h4>
                                        <p>
                                            Our dedicated partnership team will provide you with
                                            comprehensive support, including marketing materials,
                                            training, and ongoing assistance to help you succeed.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div
                                        className="
                    appie-single-service-2 appie-single-service-about
                    item-4
                    mt-30
                    wow
                    animated
                    fadeInUp
                  "
                                        data-wow-duration="2000ms"
                                        data-wow-delay="200ms"
                                    >
                                        <div className="icon">
                                            <i className="fal fa-hands-helping" />
                                        </div>
                                        <h4 className="title">Long-term partnership</h4>
                                        <p>
                                            We believe in building long-term partnerships, and we're
                                            committed to supporting your success every step of the
                                            way.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 order-0 order-xs-1 order-md-1 order-sm-0">
                            <div className="service-thumb">
                                <img src={serviceThumb} alt="Why Partner with OTO?" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default ServicesHomeEight;
